/**
 * ShellContext — pages register per-page top-bar content (breadcrumb,
 * keyboard hints, throughput rate, right-side controls) without coupling
 * to TankShell directly.
 *
 * Usage in a page:
 *   useEffect(() => {
 *     setTopBar({
 *       breadcrumb: 'Eredivisie · 28 apr',
 *       kbHints: [{ keys: ['/'], label: 'search' }],
 *       rate: '7.21 / min',
 *     });
 *     return () => setTopBar(null);
 *   }, [match]);
 */

import { createContext, useCallback, useContext, useState } from 'react';

const ShellContext = createContext({
  topRight: null,
  setTopBar: () => {},
});

export function ShellProvider({ children }) {
  const [topRight, setTopRight] = useState(null);

  const setTopBar = useCallback((next) => {
    setTopRight(next);
  }, []);

  return (
    <ShellContext.Provider value={{ topRight, setTopBar }}>
      {children}
    </ShellContext.Provider>
  );
}

export function useShellTopRight() {
  return useContext(ShellContext).topRight;
}

export function useSetTopBar() {
  return useContext(ShellContext).setTopBar;
}
